module.exports = __webpack_public_path__ + "img/Krait---most-venomous-snake-india.5d50d4c2.jpg";